import Link from "next/link";
import { LINKS } from "@/constants/article";
import readingTime from "@/functions/readingTime";
import moment from "moment";
import vector from "@/assets/blog/articles-vector.png";

export default function BlogArticleBanner({ article }) {
  const inputDate = moment(article?.created_at);
  const formattedDate = inputDate.format("MMMM DD, YYYY");

  return (
    <div className="relative">
      <img
        src={vector ?? ""}
        alt="vector"
        className="absolute w-full top-[250px] hidden sm:block max-h-[730px]"
      />
      <div className="max-w-[836px] w-full m-auto flex flex-col items-center pt-32 md:pt-16 relative px-5 text-center 3xl:max-w-[80%]">
        <div className="max-w-full overflow-hidden text-base text-ellipsis whitespace-nowrap text-purple">
          {LINKS.map(({ path, text }) => (
            <Link href={path ?? ""} key={path} className="text-silver-quick">
              {text} /{" "}
            </Link>
          ))}
          <span>{article?.title}</span>
        </div>
        <div>
          <h1 className="text-2xl sm:text-3xl md:text-[40px] xl:text-[50px]/[60px] text-purple text-center pt-6">
            {article?.title}
          </h1>
          <div className="flex gap-2 flex-wrap sm:gap-4 text-purple text-base sm:text-xl items-center pt-7 pb-5 sm:pb-[56px] justify-center">
            <img
              src={article?.author_image}
              alt="auhor"
              className="w-10 h-10 sm:w-16 sm:h-16 object-cover"
            />
            {article?.author_name && <span>By {article?.author_name}</span>}
            <div className="w-1 h-1 bg-purple"></div>
            <span>{formattedDate}</span>
            <div className="w-1 h-1 bg-purple"></div>
            <span>{readingTime(article?.content)} min read</span>
          </div>
        </div>
        <div className="w-full">
          <img
            src={article?.image}
            alt="article image"
            className="w-full object-cover h-[350px] md:h-[480px]"
          />
        </div>
      </div>
    </div>
  );
}
